import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import { Card, Col, Row } from "react-bootstrap";
import ImportContactsIcon from "@mui/icons-material/ImportContacts";
import CalculateIcon from "@mui/icons-material/Calculate";
import ScienceIcon from "@mui/icons-material/Science";
import DrawIcon from "@mui/icons-material/Draw";
import HourglassTopIcon from "@mui/icons-material/HourglassTop";

import { isEmptyObject } from "../../../../util";
import { getTotalDescriptionMarked } from "../../../../api/dashboardApi";
import { LoadingSpinner } from "../../";
import { Common } from "../../../../helper";

const CurriculumCoverage = (props) => {
  const { classOptions } = props;
  const [selectedClass, setSelectedClass] = useState();
  const [data, setData] = useState();

  // const [classOptions, setClassOptions] = useState();
  const [isLoading, setIsLoading] = useState(false);

  const getResultant = async (classId) => {
    const details = await getTotalDescriptionMarked({ classId });
    if (!isEmptyObject(details.Items)) {
      getResult(details.Items)
      setData(details.Items)
    }
  }

  const [chartData, setChartData] = useState({
    series: [],
    options: {
      chart: {
        height: 390,
        type: "radialBar",
      },
      tooltip: {
        enabled: false,
      },
      plotOptions: {
        radialBar: {
          inverseOrder: false,
          offsetY: 0,
          startAngle: 0,
          endAngle: 360,
          hollow: {
            margin: 5,
            size: "30%",
          },
          dataLabels: {
            name: {
              show: false,
            },
            value: {
              show: false,
            },
          },
        },
      },
      legend: {
        show: false,
        position: "bottom",
        horizontalAlign: "right",
      },
      stroke: {
        lineCap: "round",
      },
      colors: ["var(--secondary-button-color)", "rgba(105, 3, 117, 0.56)", "#ADE25D", "rgba(251, 54, 64, 0.59)", "rgba(85, 140, 140, 0.68)"],
      labels: [],
    },
  });

  const getResult = (data) => {
    const { percentageOfWeeks, ...subjectData } = data;
    const filteredLabels = Object.keys(subjectData).filter(label => label !== "pe");
    const seriesData = filteredLabels.map((label) => (subjectData[label].marked / subjectData[label].total) * 100);
    setChartData({
      ...chartData,
      series: [parseInt(percentageOfWeeks), ...seriesData],
      labels: ["percentageOfWeeks", ...filteredLabels],
    });
    setIsLoading(false);
  }

  useEffect(() => {
    getResultant(classOptions[0].value)
  }, [])

  return (
    <Card className="radialProgressMain">
      <Row className="d-flex flex-column">
        <Col>
          <div>
            <Col xs={12} style={{ display: "flex" }}>
              <Col xs={9}>
                <span className="topic">{Common.CurriculumCoverage}</span>
              </Col>
              <Col xs={3}>
                <select className="dropDownResult" defaultValue={selectedClass} onChange={(e) => { setSelectedClass(e.target.value); getResultant(e.target.value) }}>
                  {
                    classOptions.map((item) => {
                      return (<option key={item.value} value={item.value}>{item.label}</option>)
                    })
                  }
                </select>
              </Col>
            </Col>
            <Col xs={12}>
              <Col xs={9}>
                <p className="subTopic">{Common.ObjectivesMarkedInComparison}</p>
              </Col>
            </Col>

          </div>
        </Col>
      </Row>
      {isLoading?<LoadingSpinner />:<Row id="chart">
        <Col xs={12} style={{display : "flex", alignItems : "flex-end"}}>
          <Col xs={8}>
            <div style={{ transform: "scaleX(-1)" }}>
              {chartData.series && <ReactApexChart
                options={chartData?.options}
                series={chartData?.series}
                type="radialBar"
                height={390}
              />}
            </div>
          </Col>
          <Col xs={4}>
            <div className="d-flex flex-column" style={{ width: "-webkit-fill-available", marginLeft: "auto", marginTop: "-20%" }}>
              {data && Object.keys(data).map((label,i) => {
                if (label === "percentageOfWeeks") return (<span style={{ color: "var(--secondary-button-color)" }}><HourglassTopIcon />School Year({data[label]})</span>)
                else if (label !== "pe") {
                  return (
                    <span key={i} style={{ color: label === "science" ? "#ADE25D" : label === "maths" ? "rgba(105, 3, 117, 0.56)" : label === "writing" ? "rgba(251, 54, 64, 0.59)" : "rgba(85, 140, 140, 0.68)" }}>{label === "science" ? <ScienceIcon /> : label === "maths" ? <CalculateIcon /> : label === "reading" ? <ImportContactsIcon /> : <DrawIcon />}{label[0].toUpperCase() + label.slice(1)}({data[label].marked} / {data[label].total})</span>
                  )
                }
              })}
            </div>
          </Col>
        </Col>
      </Row>}
    </Card>
  );
}

export { CurriculumCoverage };
